export enum NoteAudioType {
  Consultation = 1,
  Dictation = 2,
}
